// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  GET_TOTALS
} from '@/graphql/dailyControl/DailyControlGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import {
  DailyControlModel,
  DailyControlsWithPagination,
  DailyControlForm,
  FiltersDailyControlModel,
  DailyControlTotals
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'

class DailyControlsService {
    /**
    * Queries
    */
    async getWithPagination (perPage = 10, page = 1, filters: FiltersDailyControlModel): Promise<DailyControlsWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage,
                filters: filters
            }
        })
        const pagination: Paginator = result.data.dailyControlsWithPagination.paginatorInfo
        const data: [DailyControlModel] = result.data.dailyControlsWithPagination.data
        const response: DailyControlsWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    async getAll (filters: FiltersDailyControlModel): Promise<DailyControlModel[]> {
        const result = await apolloClient.query({
            query: GET_ALL,
            variables: {
                filters: filters
            }
        })
        return result.data.dailyControls
    }

    async getTotals (filters: FiltersDailyControlModel): Promise<DailyControlTotals> {
        const result = await apolloClient.query({
            query: GET_TOTALS,
            variables: {
                filters: filters
            }
        })
        return result.data.getTotalDailyControl
    }

  /**
   * Mutations
   */
    async create (form: DailyControlForm): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

  async update (id: number, form: DailyControlForm): Promise<ResponseDefault> {
      await apolloClient.mutate({
          mutation: UPDATE,
          variables: {
              id: id,
              input: form
          }
      })
      return {
        success: true,
        errors: []
    }
  }

  async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
  }
}

export default new DailyControlsService()
